import { RootState } from '@/shared/store'
import { createSelector } from '@reduxjs/toolkit'

// Get the unit of measure for volume from the client preset
export const selectUomVolume = createSelector(
  [state => state],
  (state: RootState) => state.user.client?.UomVolume || '',
)
